import React from 'react';
import './stepperHorizontal.css';

const StepperHorizontal = ({
  steps = [],
  currentStep = 0,
  onStepClick,
  canNavigateTo,
}) => {
  return (
    <div className='stepper'>
      {steps.map((step, idx) => {
        const isCompleted = idx < currentStep;
        const isActive = idx === currentStep;
        const isClickable = canNavigateTo ? canNavigateTo(idx) : true;

        const circleClass = isActive
          ? 'stepper__circle stepper__circle--active'
          : isCompleted
            ? 'stepper__circle stepper__circle--completed'
            : 'stepper__circle stepper__circle--pending';

        const labelClass = isActive
          ? 'mt-2 mini stepper__label--active'
          : isCompleted
            ? 'mt-2 mini stepper__label--completed'
            : 'mt-2 mini stepper__label--pending';

        const isBlue = isActive || isCompleted;
        const iconColor = isBlue ? 'var(--white)' : 'var(--gray-600)';

        const icon = step.icon ? (
          (() => {
            const iconName = step.icon.props?.name;

            const fillIcons = ['fileEarmarkText'];

            if (fillIcons.includes(iconName)) {
              return React.cloneElement(step.icon, {
                fill: iconColor,
              });
            }

            return React.cloneElement(step.icon, {
              stroke: iconColor,
            });
          })()
        ) : (
          <span className='stepper__num'>{idx + 1}</span>
        );

        return (
          <React.Fragment key={step.label || idx}>
            <div
              className={`stepper__item ${
                isClickable ? 'stepper__item--clickable' : ''
              }`}
              onClick={() => {
                if (isClickable) {
                  onStepClick?.(idx);
                }
              }}
              style={{ cursor: isClickable ? 'pointer' : 'default' }}
            >
              <div className={circleClass}>
                <div className='stepper__icon'>{icon}</div>
              </div>
              <div className={labelClass}>{step.label}</div>
            </div>
            {idx < steps.length - 1 && (
              <div
                className={
                  idx < currentStep
                    ? 'stepper__line stepper__line--active'
                    : 'stepper__line stepper__line--pending'
                }
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepperHorizontal;
